/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
        suggestionMobileStyle: 'style2'
	}
};

(function() {
	BoostPFS.inject(this);

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  InstantSearchResult.prototype.render = function() {
		if (this.isFirstLoad) {
			// Render initial suggestion container and append it to the dom.
			// MUST append to <body>, NOT form.search-form: the form sits inside
			// .rsf-drawer which has transform:translateX() — `transform` on an
			// ancestor creates a containing block for position:fixed children,
			// so popup top:Xpx becomes drawer-relative instead of viewport-relative,
			// adding ~63px gap below the input. Appending to body bypasses this.
			var suggestionHtml = this.compileTemplate();
			this.appendToSelector = 'body';
			this._applyFilterAutocompleteAppendElement();

			jQ(this.appendToSelector).append(suggestionHtml);
			this.$wrapper = jQ(this.selector.wrapper);
			this.$popoverElement = jQ(this.selector.popover);
			this.isFirstLoad = false;
		} else {
			// Show the suggestion popover and suggestion itself
			this.$instantSearchResult.show();
			this.$instantSearchResult.siblings().show();
			// Render suggestion blocks and items
			if (this.isLoading) {
				this._renderSuggestionLoading();
				this._renderWrapper();
			} else {
				this._renderWrapper();
				this._renderSuggestion();
			}

		}
	}

  // Pin Boost search suggestion popup to actual #search-mobile bottom (drawer mobile).
  // CSS uses var(--rsf-search-suggestion-top) under the same media query so it always
  // matches the rendered input position regardless of announcement bar / header height.
  function updateRsfSearchAnchor() {
    var input = document.querySelector('.rsf-drawer__search input.boost-pfs-search-input');
    if (!input) {
      window.RSFDebug = { error: 'no #search-mobile' };
      return;
    }
    var rect = input.getBoundingClientRect();
    window.RSFDebug = {
      inputRect: { top: rect.top, bottom: rect.bottom, left: rect.left, right: rect.right, width: rect.width, height: rect.height },
      viewport: [window.innerWidth, window.innerHeight],
      drawerOpen: !!document.querySelector('.rsf-drawer.is-open'),
      skipped: rect.height === 0 || rect.left < 0 || rect.width < 50
    };
    if (rect.height === 0 || rect.left < 0 || rect.width < 50) return;
    document.documentElement.style.setProperty('--rsf-search-suggestion-top', Math.round(rect.bottom) + 'px');
    document.documentElement.style.setProperty('--rsf-search-suggestion-left', Math.round(rect.left) + 'px');
    document.documentElement.style.setProperty('--rsf-search-suggestion-width', Math.round(rect.width) + 'px');
    window.RSFDebug.applied = {
      top: getComputedStyle(document.documentElement).getPropertyValue('--rsf-search-suggestion-top'),
      left: getComputedStyle(document.documentElement).getPropertyValue('--rsf-search-suggestion-left'),
      width: getComputedStyle(document.documentElement).getPropertyValue('--rsf-search-suggestion-width')
    };
  }
  var rsfSearchAnchorInitialized = false;
  function initRsfSearchAnchor() {
    if (rsfSearchAnchorInitialized) return;
    var input = document.querySelector('.rsf-drawer__search input.boost-pfs-search-input');
    var drawer = document.querySelector('.rsf-drawer');
    if (!input || !drawer) {
      window.RSFDebug = { error: 'init waiting', hasInput: !!input, hasDrawer: !!drawer, readyState: document.readyState };
      return; // body MutationObserver below will retry when drawer/input get added
    }
    rsfSearchAnchorInitialized = true;
    updateRsfSearchAnchor();
    window.addEventListener('resize', updateRsfSearchAnchor);
    window.addEventListener('scroll', updateRsfSearchAnchor, true);
    // Listen on stable parent .rsf-drawer__search via capture — Boost may
    // replace the input element after binding (changes id, may swap node),
    // so direct listeners on `input` would be lost.
    var searchContainer = document.querySelector('.rsf-drawer__search');
    if (searchContainer) {
      searchContainer.addEventListener('focus', updateRsfSearchAnchor, true);
      searchContainer.addEventListener('input', updateRsfSearchAnchor, true);
    }
    var mo = new MutationObserver(function() {
      setTimeout(updateRsfSearchAnchor, 50);
      setTimeout(updateRsfSearchAnchor, 320);
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  // Try to init now; if drawer/input not yet in DOM, observe body and retry on each mutation.
  initRsfSearchAnchor();
  if (!rsfSearchAnchorInitialized) {
    var bodyObserver = new MutationObserver(function() {
      initRsfSearchAnchor();
      if (rsfSearchAnchorInitialized) bodyObserver.disconnect();
    });
    if (document.body) {
      bodyObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        initRsfSearchAnchor();
        if (!rsfSearchAnchorInitialized && document.body) {
          bodyObserver.observe(document.body, { childList: true, subtree: true });
        }
      });
    }
    document.addEventListener('DOMContentLoaded', initRsfSearchAnchor);
    window.addEventListener('load', initRsfSearchAnchor);
  }

})();